import axios from "axios";
import { SETTINGS } from "../../Settings";

export const UserRepository = {
  getCurrentUser: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/current`,
      method: "GET",
    });
  },

  getAll: (page, size, filterData, orderBy, orderDirection) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/all`,
      method: "POST",
      params: {
        page: page,
        size: size,
        username: filterData?.username,
        role: filterData?.role,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
    });
  },

  getById: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/${id}`,
      method: "GET",
    });
  },

  save: (userData) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users`,
      method: "PUT",
      data: userData,
    });
  },

  create: (userData) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users`,
      method: "POST",
      data: userData,
    });
  },

  activateAccount: (data) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/activateAccount`,
      method: "POST",
      data: data,
    });
  },

  getAllRoles: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/roles`,
      method: "GET",
    });
  },

  getNotificationsForUser: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/users/notifications`,
      method: "GET",
    });
  },
};
